import React from "react";
import {connect} from "react-redux";
import {Animated, Dimensions, Image, Keyboard, StyleSheet, Text, TouchableOpacity, View} from "react-native";
import MyTheme from "../../Theme/Theme";
import {getThemes} from "../../API/api-static";
import {UseFocusComponent} from "../../utils/func";
import ExplorerContactList from "../Explorer/ExplorerContactList";
import ExplorerThemeList from "../Explorer/ExplorerThemeList";

import Tabs from "../Menu/Tabs";
import {
    getAllContact,
    getAllEntity,
    getAllTheme,
    getFeedNormal, getFocusContact, getFocusEntity, getFocusTheme, getOneContact, getOneEntity,
    setFocusContact, setFocusEntity, setFocusTheme,
    setNotifyContact, setNotifyEntity, setNotifyTheme
} from "../../API/API";
import ModifierPicto from "../Picto/ModifierPicto";
import BoutonGenerale from "../Bouton/BoutonGenerale";
import BoutonText from "../Bouton/BoutonText";
import {ChevronGaucheMediumPicto} from "../Picto/ChevronGaucheMediumPicto";
import {withTranslation} from "react-i18next";
import {compose} from "redux";
import {wrapAction, wrapStyle} from "../../sw/helpers";

function is_focus_enabled(item_id, focus) {
  const item = focus[item_id];
  return item ? item.focus_enabled : false;
}

function is_notification_enabled(item_id, focus) {
  const item = focus[item_id];
  return item ? item.notification_enabled : false;
}

class FocusScreen extends React.Component{

    constructor(props) {
        super(props);
        this.feeds = {
            contact:
                {
                    Title : 'Contacts',
                    Feed: [],
                    refresh : this._getContact,
                    avatar : true
                },
            entity:
                {
                    Title : 'Entités',
                    Feed : [],
                    refresh : this._getEntity,
                    avatar : true
                },
            theme:
                {
                    Title : 'Thèmes',
                    Feed : [],
                    refresh : this._getTheme,
                    avatar : false
                }
        };

        this.data = Object.keys(this.feeds).map((i) => ({
            key: i,
            title: this.feeds[i].Title,
            feed : this.feeds[i].Feed,
            refresh : this.feeds[i].refresh,
            avatar : this.feeds[i].avatar,
            ref : React.createRef()
        }));

        const {
	  focus_set, focus_unset,
	  notification_set, notification_unset
	} = this.getDefaultListSetUnSet();

        this.state = {
            scrollX: new Animated.Value(0),
            activeTab : 0,
            data : [],
            cursor : undefined,
            currentCursor : undefined,
            nextCursor : undefined,
            isRefresh  : false,
            timeParution : 1,
            update : false,
            modalVisible : false,
            focusList : {contact: [],entity:[],theme:[]},
            notificationList : {contact: [],entity:[],theme:[]},
            focusListSet: focus_set,
            focusListUnSet: focus_unset,
            notificationListSet: notification_set,
            notificationListUnSet: notification_unset,
            last_focus_count: 0
        }

        this._getContact();
        this._getEntity();
        this._getTheme();

        this.setActiveTab = this.setActiveTab.bind(this);
        this.setTimeParution = this.setTimeParution.bind(this);
        this._setUpdate = this._setUpdate.bind(this);
        this.setFocusList = this.setFocusList.bind(this);
        this.setNotificationList = this.setNotificationList.bind(this);
        this._confirmUpdate = this._confirmUpdate.bind(this);
        this._cancelUpdate = this._cancelUpdate.bind(this);
        this.navigateToEntityScreen = this.navigateToEntityScreen.bind(this);
        this.mref =React.createRef();
        this._setHeader();
    }

    navigateToEntityScreen(item){
        this.props.navigation.navigate("EntityScreen",{id:item.id,type: "theme"});
    }


    getDefaultListSetUnSet() {
      return {
        focus_set: {contact: [], entity: [], theme: []},
        focus_unset: {contact: [], entity: [], theme: []},
        notification_set: {contact: [], entity: [], theme: []},
        notification_unset: {contact: [], entity: [], theme: []}
      }
    }

    getDimensions() {
      return Dimensions.get('window');
    }

    onItemPress = (itemIndex) => {
        const { width } = this.getDimensions();

        this.mref.current.scrollToOffset({
            offset : itemIndex * width
        });
        Keyboard.dismiss();
    }

    setActiveTab(){
        const { width } = this.getDimensions();

        let activeTab = Math.round(this.state.scrollX._value/width);
        this.setState({
            activeTab : activeTab
        });
    }

    setTimeParution(value){
        this.setState({
            timeParution : value
        });
    }

    _setHeader(){
        const styleHeaderGlobalWhite = {
            shadowOpacity: 0,
            shadowRadius: 0,
            borderWidth:0,
            elevation: 0,
            borderColor:"transparent" ,
            borderBottomWidth:0,
            backgroundColor : this.props.theme.colors.primary.White.value,
            height:80
        }  ;

        this.props.navigation.setOptions({
            headerTitleAlign: "center",
            headerTitle:this.props.t("Mes focus"),
            headerStyle:styleHeaderGlobalWhite,
            headerTitleStyle:{fontFamily: this.props.theme.fonts.title},
            headerRight : ()=>
                (<TouchableOpacity onPress={wrapAction(this._setUpdate)} style={wrapStyle({})} >
                <ModifierPicto style={{width:20,height:17,flex : 1,marginRight:20 } } isHeader={true} />
            </TouchableOpacity>),
            headerLeft : ()=>
                (<TouchableOpacity onPress={this.props.navigation.goBack}>
                    <Image resizeMode={"contain"} style={{width:20,height: 20,marginLeft:20, flex: 1}} source={this.props.theme.pictos.chevronGaucheMediumPicto.light} />
                 </TouchableOpacity>)});

    }

    _setUpdateHeader(){

        this.props.navigation.setOptions({
            headerTitle : this.props.t("Modifier mes focus"),
            headerTitleStyle:{fontFamily: this.props.theme.fonts.title},
            headerLeft : ()=>
                <View style={{marginLeft:20}}  >
                    <BoutonText onPress={this._cancelUpdate} style={{textParent :{color : this.props.theme.colors.primary.blue1.value} }}
                                bold={false} isRed={false} title={this.props.t("Annuler")} />
                </View>,
            headerRight : ()=>
                <View style={wrapStyle({})}>
                    <BoutonGenerale onPress={wrapAction(this._confirmUpdate)} title={this.props.t("Valider")}
                                    isActivate={true} size={"medium"} hasBorder={false}/>
                </View>
        });
    }

    _setUpdate(){
        this.setState({
            update : true
        });
        this._setUpdateHeader();
        this._getAllContact();
        this._geAllEntity();
        this._getAllTheme();
    }

    _cancelUpdate(){
      this.reload()
    }

    reload() {
        const {
	  focus_set, focus_unset,
	  notification_set, notification_unset
	} = this.getDefaultListSetUnSet();

        this.setState({
            focusListSet : focus_set,
            focusListUnSet : focus_unset,
            notificationListSet : notification_set,
            notificationListUnSet : notification_unset,
            update : false
        });

        // FIXME: is it needed? We cancelled everything!
        this._getContact();
        this._getEntity();
        this._getTheme();
        this._setHeader();
    }

    // for each type, loop over set/unset list and call the API action
    // one by one, returning a promise
    _updateFocus(){
        const {
	  focusListSet, focusListUnSet, focusList,
	  notificationListSet, notificationListUnSet, notificationList
	} = this.state;

        const params = {
	  focus: {
	    funcs: {
	      contact: setFocusContact,
	      theme: setFocusTheme,
	      entity: setFocusEntity
	    },
	    listSet: focusListSet,
	    listUnSet: focusListUnSet,
	    list: focusList
	  },
	  notification: {
	    funcs: {
	      contact: setNotifyContact,
	      theme: setNotifyTheme,
	      entity: setNotifyEntity,
	    },
	    listSet: notificationListSet,
	    listUnSet: notificationListUnSet,
	    list: notificationList
	  }
        };

	const buildPromises = ({funcs, list, listSet, listUnSet}) => {
	  const promises = ["contact", "theme", 'entity'].flatMap(type => {
	    const set = listSet[type], unset = listUnSet[type],
		  existing = list[type], func = funcs[type];

	    // remove duplicates w/ originally set focus
	    const set2 = set.filter(x => !existing.some(y => x.id == y.id));
	    const unset2 = unset.filter(x => existing.some(y => x.id == y.id));

	    return set2.map(x => func(x.id, "set")).concat(
	      unset2.map(x => func(x.id, "unset"))
	    )
	  });
	  return Promise.all(promises);
	}

	// don't update notification and focus at the same time: it might override oO
	// commit one then run the other
        return buildPromises(params.focus).then(() => {
	  return buildPromises(params.notification);
	});
    }


    _confirmUpdate(){

        this._updateFocus().then(() => {

	  const {
	    focus_set, focus_unset,
	    notification_set, notification_unset
	  } = this.getDefaultListSetUnSet();

          this._getContact();
          this._getEntity();
          this._getTheme();
          this.setState({
              update : false,
	      focusListSet: focus_set,
	      focusListUnSet: focus_unset,
	      notificationListSet: notification_set,
	      notificationListUnSet: notification_unset
          });
          this._setHeader();

        });

    }

    _deconnexion(){
        const action = {'type': 'SIGN_OUT', 'value': ""};
        this.props.dispatch(action);
    }

   _getContact(){
        getFocusContact().then(focus => {
            if(focus=="Not Acceptable"){
                this._deconnexion();
                return
            }

            this._fetchContacts(focus).then(contacts => {
              this.feeds.contact.Feed = contacts;

	      const focus_list = contacts.filter(c => is_focus_enabled(c.id, focus));
	      const notif_list = contacts.filter(c => is_notification_enabled(c.id, focus));

              this.data = Object.keys(this.feeds).map((i) => ({
                  key: i,
                  title: this.feeds[i].Title,
                  image: this.feeds[i].Image,
                  feed: this.feeds[i].Feed,
                  refresh : this.feeds[i].refresh,
                  ref : React.createRef()
              }));

              this.setState({
                  data : this.data,
                  focusList : {
                    ...this.state.focusList,
                    contact: focus_list
                  },
                  notificationList : {
                    ...this.state.notificationList,
                    contact: notif_list
                  }
              });
            })

        });
    }

    _fetchContacts(focus_contact) {
	const ids = Object.keys(focus_contact);
        return Promise.all(ids.map(getOneContact));
    }

    _fetchEntities(focus_entity) {
	const ids = Object.keys(focus_entity);
        return Promise.all(ids.map(getOneEntity));
    }

    _getAllContact(){
        getAllContact().then(data => {
            if(data=="Not Acceptable"){
                this._deconnexion(); return;
            }

            this.feeds.contact.Feed = data.data;
            this.data = Object.keys(this.feeds).map((i) => ({
                key: i,
                title: this.feeds[i].Title,
                image: this.feeds[i].Image,
                feed : this.feeds[i].Feed,
                refresh : this.feeds[i].refresh,
                ref : React.createRef()
            }));

            this.setState({ data : this.data });
        });
    }

    _getEntity(){
        getFocusEntity().then(focus=>{
            if(focus=="Not Acceptable"){
                this._deconnexion();
                return
            }

            this._fetchEntities(focus).then(entities => {
                this.feeds.entity.Feed = entities;

		const focus_list = entities.filter(c => is_focus_enabled(c.id, focus));
		const notif_list = entities.filter(c => is_notification_enabled(c.id, focus));

                this.data = Object.keys(this.feeds).map((i) => ({
                    key: i,
                    title: this.feeds[i].Title,
                    image: this.feeds[i].Image,
                    feed : this.feeds[i].Feed,
                    refresh : this.feeds[i].refresh,
                    ref : React.createRef()
                }));

                this.setState({
                    data : this.data,
                    focusList : {
                      ...this.state.focusList,
                      entity : focus_list
                    },
		    notificationList : {
		      ...this.state.notificationList,
		      entity: notif_list
		    }
                });
            })
        });
    }

    _geAllEntity(){
        getAllEntity().then(data=>{
            if(data=="Not Acceptable"){
                this._deconnexion(); return;
            }

            this.feeds.entity.Feed = data.data;

            this.data = Object.keys(this.feeds).map((i) => ({
                key: i,
                title: this.feeds[i].Title,
                image: this.feeds[i].Image,
                feed : this.feeds[i].Feed,
                refresh : this.feeds[i].refresh,
                ref : React.createRef()
            }));

            this.setState({ data : this.data });
        });
    }

    _getTheme(){
        getFocusTheme().then(focus => {
            if(focus=="Not Acceptable"){
                this._deconnexion(); return;
            }

            getAllTheme().then(all_themes=>{

		// flatten by id to then map w/ focus
                let themes = {};
                all_themes.forEach(root => {
                  themes[root.id] = root;
                  root.children.forEach(subroot => {
                    themes[subroot.id] = subroot;
                    subroot.children.forEach(leaf => {
                      themes[leaf.id] = leaf;
                    })
                  })
                })

		let active_themes = Object.keys(focus).sort((id_a, id_b) => id_a - id_b);

		const focus_list =
		  active_themes
		  .filter(id => is_focus_enabled(id, focus))
		  .map(id => themes[id]);

		const notif_list =
		  active_themes
		  .filter(id => is_notification_enabled(id, focus))
		  .map(id => themes[id]);

                this.feeds.theme.Feed = all_themes;

                this.data = Object.keys(this.feeds).map((i) => ({
                    key: i,
                    title: this.feeds[i].Title,
                    image: this.feeds[i].Image,
                    feed : this.feeds[i].Feed,
                    refresh : this.feeds[i].refresh,
                    ref : React.createRef()
                }));

                const { width } = this.getDimensions();

                this.setState({
                    data : this.data,
                    focusList : {...this.state.focusList, theme: focus_list},
		    notificationList : {...this.state.notificationList, theme: notif_list}
                });

            });
        });
    }

    _getAllTheme(){
        getAllTheme().then(all_themes => {
            if(all_themes=="Not Acceptable"){
                this._deconnexion(); return;
            }

            this.feeds.theme.Feed = all_themes;

            this.data = Object.keys(this.feeds).map((i) => ({
                key: i,
                title: this.feeds[i].Title,
                image: this.feeds[i].Image,
                feed : this.feeds[i].Feed,
                refresh : this.feeds[i].refresh,
                ref : React.createRef()
            }));

            this.setState({ data : this.data });
        });
    }

    setFocusList(type, is_set, item){
        let set = this.state.focusListSet[type],
            unset = this.state.focusListUnSet[type];

        if (is_set) {
          set = set.concat([item]);
          unset = unset.filter(x => x.id != item.id);
        } else {
          set = set.filter(x => x.id != item.id);
          unset = unset.concat([item]);
        }

        this.setState({
            focusListSet : {...this.state.focusListSet, [type]: set},
            focusListUnSet : {...this.state.focusListUnSet, [type]: unset}
        });
    }

    // same as setFocusList
    setNotificationList(type, is_set, item){
        let set = this.state.notificationListSet[type],
            unset = this.state.notificationListUnSet[type];

        if (is_set) {
          set = set.concat([item]);
          unset = unset.filter(x => x.id != item.id);
        } else {
          set = set.filter(x => x.id != item.id);
          unset = unset.concat([item]);
        }

        this.setState({
            notificationListSet : {...this.state.notificationListSet, [type]: set},
            notificationListUnSet : {...this.state.notificationListUnSet, [type]: unset}
        });
    }

    componentDidMount() {
        const { width } = this.getDimensions();

        this.setState({
            activeTab : width/this.state.scrollX || 0,
            data : this.data
        });
    }

    componentDidUpdate() {
        if(this.state.update){
            this._setUpdateHeader();
        }else{
            this._setHeader();
        }
    }

    render() {
        // <UserInactivity timeForInactivity={90000} onAction={() => {const action = {'type': 'SIGN_OUT_NIP', 'value':{}};this.props.dispatch(action);}} >
        const { width, height } = this.getDimensions();

	const runInUseEffect = ({ focusCount, isFocused }) => {
	  // console.log("RUNNING: ", focusCount, isFocused, this.state.last_focus_count);
	  if (focusCount > 1 && isFocused && this.state.last_focus_count < focusCount) {
	    // console.log("UPDATE: ", focusCount, isFocused);
	    this.setState({last_focus_count: focusCount});
	    this.reload();
	  }
	}

        const onHorizontalScrollChangeTab = Animated.event(
          [{nativeEvent: {contentOffset: {x: this.state.scrollX}}}],
          {listener: (event) => { this.setActiveTab() }, useNativeDriver:false}
        )

        const itemsFactory = {
          "contact": { El: ExplorerContactList, type: "contact", isEntity: false },
          'entity': { El: ExplorerContactList, type: 'entity', isEntity: true },
          "theme": { El: ExplorerThemeList, type: "theme"},
        };

        const renderItem = (item) => {
          if (!item.item.feed || item.item.feed.length == 0) {
            return <View style={{width: width, height: height, justifyContent: "center", alignItems: "center"}}>
                <Text style={{color : this.props.theme.colors.tertiary.black1.value}}>{this.props.t('Aucun élément à afficher')}</Text>
            </View>
          }
          const cp = item.item.feed.slice();
          const {El, type, isEntity} = itemsFactory[item.item.key];


          const focus_set = this.state.focusListSet[type],
		focus_unset = this.state.focusListUnSet[type],
                notification_set = this.state.notificationListSet[type],
		notification_unset = this.state.notificationListUnSet[type],
		focusList = this.state.focusList[type],
		notificationList = this.state.notificationList[type]
		;

          return <El data={cp} isFocus={true}
                    navigateToEntityScreen={this.navigateToEntityScreen}

                    // focus
		    setFocusList={this.setFocusList}
                    focusListSet={focus_set}
                    focusListUnSet={focus_unset}
                    focusList={focusList}
                    // notif
		    setNotificationList={this.setNotificationList}
                    notificationListSet={notification_set}
                    notificationListUnSet={notification_unset}
                    notificationList={notificationList}

                    refNavigation={this.props.navigation}
                    // boolean indicating if we are in update mode
                    type={type} isUpdate={this.state.update} isEntity={isEntity}
            />;
        }

        return (<View style={{flex:1,flexDirection:"column"}}>
                <UseFocusComponent navigation={this.props.navigation} cbForUseEffect={runInUseEffect} />
                <Tabs style={{top:10}} scrollX={this.state.scrollX} total_width={width}
                      data={this.data} indexActive={this.state.activeTab} onItemPressCallBack={this.setActiveTab} onItemPress={this.onItemPress}/>

                <Animated.FlatList
                    style={{marginTop:60,flex:1,overflow:"scroll"}}
                    ref={this.mref}
                    data={this.data}
                    keyExtractor={item=>item.key}
                    horizontal={true}
                    showsHorizontalScrollIndicator={false}
                    pagingEnabled={true}
                    bounces={false}
                    onScroll={onHorizontalScrollChangeTab}
                    renderItem={renderItem}
                />
            </View>
        );
    }
}

const mapStateToProps = (state) => {
    return {
      isDark: state.changeTheme.isDark, theme: state.changeTheme.theme, auth: state.AuthReducer,
      online: state.sw_reducer.online
    };
}


export default compose(connect(mapStateToProps),withTranslation())(FocusScreen);
